import type { Op } from 'quill/core';
import { Delta } from 'quill/core';

export const getFirstLineFromDelta = (delta: Delta): Delta | null => {
  let foundLine: Delta | null = null;
  delta.eachLine((line) => {
    foundLine = line;
    return false;
  });
  return foundLine;
};

export const removeFirstLineFromDelta = (delta: Delta) => {
  const firstLine = getFirstLineFromDelta(delta);
  if (!firstLine) {
    return delta;
  }

  return delta.compose(new Delta().delete(firstLine.length() + 1));
};

export const deltaOnlyContainWhitespace = (ops: Op[]) =>
  ops.every(({ insert }) => typeof insert === 'string' && !insert.trim());
